<menu class="widget-menu">
  <ul>
    <li *ngFor="let item of widget.data.items" [ngClass]="getItemClasses(item)">
      <a [routerLink]="item.url">{{item.text}}</a>
    </li>
  </ul>
</menu>
